export const ADVISOR = {
  employee: {
    fabButton: 'advisor-employee-fab-button',
    sheetTitle: 'advisor-employee-sheet-title',
    closeButton: 'advisor-employee-close-button',
    newSessionButton: 'advisor-employee-new-session-button',
    userBubble: 'advisor-employee-user-bubble',
    assistantBubble: 'advisor-employee-assistant-bubble',
    messageInput: 'advisor-employee-message-input',
    sendButton: 'advisor-employee-send-button',
  },
  admin: {
    fabButton: 'advisor-admin-fab-button',
    sheetTitle: 'advisor-admin-sheet-title',
    closeButton: 'advisor-admin-close-button',
    newSessionButton: 'advisor-admin-new-session-button',
    userBubble: 'advisor-admin-user-bubble',
    assistantBubble: 'advisor-admin-assistant-bubble',
    messageInput: 'advisor-admin-message-input',
    sendButton: 'advisor-admin-send-button',
    promptSettingsButton: 'advisor-admin-prompt-settings-button',
    promptTextarea: 'advisor-admin-prompt-textarea',
    promptSaveButton: 'advisor-admin-prompt-save-button',
    promptCancelButton: 'advisor-admin-prompt-cancel-button',
    promptBackButton: 'advisor-admin-prompt-back-button',
    contextChip: 'advisor-admin-context-chip',
    clearContextButton: 'advisor-admin-clear-context-button',
  },
};
